import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const listItemStyle = css`
  padding: ${theme.spacing(1, 2)};
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: ${theme.spacing(1)};
  :hover {
    background-color: ${theme.colors.neutral10};
  }
`;

export const checkIconStyle = css`
  margin-left: auto;
`;
